import "core-js/modules/es.array.includes.js";
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-49f6ec78"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  id: "qna",
  class: "mx-auto wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("常見問題");

const _hoisted_3 = {
  class: "text-white lh-lg text-start"
};
const _hoisted_4 = {
  class: "w-100 d-flex align-items-center px-2"
};
const _hoisted_5 = {
  class: "me-auto"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "gray-60 fs-lg lh-base px-2"
};
import { ref } from 'vue';
import plus from '@/assets/icon/plus.svg';
import minus from '@/assets/icon/minus.svg';
export default {
  __name: 'QNABlock',

  setup(__props) {
    const activeNames = ref([]);
    const list = [{
      question: 'Demi Trader 團隊的背景？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }, {
      question: 'Demi God NFT 賦能有什麼？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }, {
      question: 'Demi God NFT 該如何登記？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }, {
      question: '何時公布中獎名單？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }, {
      question: '何時查看我中獎的 NFT？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }, {
      question: '有無相關討論社群？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }, {
      question: 'Demi 團隊的背景是什麼？',
      answer: 'Demi God NFT 發行 1,688 張，為 InvestNFT 聯名台灣知名團隊 Demiverse 、元富證券所發行的 NFT'
    }];
    return (_ctx, _cache) => {
      const _component_landing_title = _resolveComponent("landing-title");

      const _component_el_collapse_item = _resolveComponent("el-collapse-item");

      const _component_el_collapse = _resolveComponent("el-collapse");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_landing_title, null, {
        default: _withCtx(() => [_hoisted_2]),
        _: 1
      }), _createElementVNode("div", _hoisted_3, [_createVNode(_component_el_collapse, {
        modelValue: activeNames.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => activeNames.value = $event),
        onChange: _ctx.handleChange
      }, {
        default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item, index) => {
          return _createVNode(_component_el_collapse_item, {
            key: index,
            class: "font-h6",
            name: index
          }, {
            title: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.question), 1), _createElementVNode("img", {
              src: activeNames.value.includes(index) ? _unref(minus) : _unref(plus),
              alt: ""
            }, null, 8, _hoisted_6)])]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(item.answer), 1)]),
            _: 2
          }, 1032, ["name"]);
        }), 64))]),
        _: 1
      }, 8, ["modelValue", "onChange"])])]);
    };
  }

};